// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Box, Button, CircularProgress, TextField } from "@mui/material";
// import { fetchOverallBookWiseReport } from "../../../redux/reportSummarySlice";
// import { fetchBookwiseReport } from "../../../redux/reportBookwiseSlice";
// import SummaryPage from "./SummaryPage";
// import { logger } from "../../../utils/logger";

// const SummaryFilter = () => {
//   const [fromBookNo, setFromBookNo] = useState("");
//   const [toBookNo, setToBookNo] = useState("");
//   const [isClicked, setIsClicked] = useState(false);
//   const [setYearWise, setSetYearWise] = React.useState(false);
//   const dispatch = useDispatch();
//   const [summary, setSummary] = useState("");
//   const [summaryType, setSumaryType] = useState("");
//   const [loading, setLoading] = useState(false);
//   const { user } = useSelector((state) => state.auth);

//   useEffect(() => {}, [summary]);
//   const handlefetchall = async () => {
//     try {
//       setIsClicked(true);
//       setLoading(true);
//       const response = await dispatch(fetchOverallBookWiseReport());
//       if (response.payload) {
//         setSummary(response.payload);
//         setSumaryType("BookwiseOverall");
//         logger.info("Filter applied successfully", {
//           filterType: "Summary - Bookwise Overall",
//           username: user?.username,
//           role: user?.role,
//         });
//       } else {
//         setSummary("");
//         setSumaryType("");
//         logger.warn("Filter applied but no data found", {
//           filterType: "Summary - Bookwise Overall",
//           username: user?.username,
//           role: user?.role,
//         });
//       }
//     } catch (error) {
//       logger.error("Error occur during Summary Report Filter applied", {
//         error: error,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFilter = async () => {
//     setIsClicked(true);
//     setLoading(true);
//     setSummary("");
//     if (fromBookNo && toBookNo) {
//       const from = fromBookNo;
//       const to = toBookNo;

//       try {
//         const response = await dispatch(fetchBookwiseReport({ from, to }));
//         if (response.payload) {
//           setSummary(response.payload);
//           setSumaryType("BookwiseOverall");
//           logger.info("Filter applied successfully", {
//             filterType: "Summary Bookwise (From/To book No)",
//             fromBook: from,
//             toBookNo: to,
//             username: user?.username,
//             role: user?.role,
//           });
//         } else {
//           setSummary("");
//           setSumaryType("");
//           logger.warn("Filter applied but no data found", {
//             filterType: "Summary Bookwise (From/To book No)",
//             username: user?.username,
//             role: user?.role,
//           });
//         }
//       } catch (err) {
//         logger.error("Error occur during summary report filter", {
//           error: err,
//         });
//         console.error("Dispatch failed", err);
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   return (
//     <>
//       <Box 
//         sx={{
//           display: "flex",
//           flexWrap: "wrap",
//           alignItems: "center",
//           gap: 2,
//           marginBottom: 2,
//         }}
//       >
//         <TextField
//           label="From Book No"
//           value={fromBookNo}
//           onChange={(e) => {
//             const value = e.target.value;
//             if (/^[a-zA-Z0-9]*$/.test(value)) {
//               setFromBookNo(value);
//             }
//           }}
//           size="small"
//         />
//         <TextField
//           label="To Book No"
//           value={toBookNo}
//           onChange={(e) => {
//             const value = e.target.value;
//             if (/^[a-zA-Z0-9]*$/.test(value)) {
//               setToBookNo(e.target.value);
//             }
//           }}
//           size="small"
//         />

//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => handleFilter()}
//         >
//           Apply Filter
//         </Button>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={() => handlefetchall()}
//         >
//           Overall Bookwise Summary
//         </Button>
//       </Box>

//       {loading ? (
//         <Box textAlign="center" mt={2}>
//           <CircularProgress />
//         </Box>
//       ) : summary || summary.length > 0 ? (
//         <SummaryPage data={summary} type={summaryType} />
//       ) : (
//         isClicked && (
//           <Box textAlign="center" mt={2} fontWeight="bold" color="black">
//             No Summary Available
//           </Box>
//         )
//       )}
//     </>
//   );
// };

// export default SummaryFilter;

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import {
  fetchOverallBookWiseReport,
  fetchYearwiseBookwiseSummary,
} from "../../../redux/reportSummarySlice";
import SummaryPage from "./SummaryPage";
import { logger } from "../../../utils/logger";
import { fetchReportFormat } from "../../../redux/reportSettingsSlice";
// Year dropdown options: current year down to 2000


const SummaryFilter = () => {
  const [fromBookNo, setFromBookNo] = useState("");
  const [toBookNo, setToBookNo] = useState("");
  const [year, setYear] = useState(""); // "" = all years (Format 1)
  const [isClicked, setIsClicked] = useState(false);
  const dispatch = useDispatch();
  const [summary, setSummary] = useState("");
  const [summaryType, setSumaryType] = useState("");
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const { format: reportFormat , minYear } = useSelector((state) => state.reportSettings);

  const currentYear = new Date().getFullYear();
const yearOptions = Array.from(
  { length: currentYear - minYear + 1 },
  (_, i) => currentYear - i
);
  useEffect(() => {}, [summary]);
  useEffect(() => {
  dispatch(fetchReportFormat());
}, [dispatch]);

  const handlefetchall = async () => {
    try {
      setIsClicked(true);
      setLoading(true);
      const response = await dispatch(fetchOverallBookWiseReport());
      if (response.payload) {
        setSummary(response.payload);
        setSumaryType("BookwiseOverall");
        logger.info("Filter applied successfully", {
          filterType: "Summary - Bookwise Overall",
          username: user?.username,
          role: user?.role,
        });
      } else {
        setSummary("");
        setSumaryType("");
        logger.warn("Filter applied but no data found", {
          filterType: "Summary - Bookwise Overall",
          username: user?.username,
          role: user?.role,
        });
      }
    } catch (error) {
      logger.error("Error occur during Summary Report Filter applied", {
        error: error,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = async () => {
    setIsClicked(true);
    setLoading(true);
    setSummary("");
    if (fromBookNo && toBookNo) {
      try {
        const response = await dispatch(
          fetchYearwiseBookwiseSummary({ fromBookNo, toBookNo, year })
        );
        if (response.payload) {
          setSummary(response.payload);
          setSumaryType("BookwiseYearly");
          logger.info("Filter applied successfully", {
            filterType: year
              ? "Summary Bookwise (Year Filter)"
              : "Summary Bookwise (Year Grouped)",
            fromBookNo,
            toBookNo,
            year: year || "All",
            username: user?.username,
            role: user?.role,
          });
        } else {
          setSummary("");
          setSumaryType("");
          logger.warn("Filter applied but no data found", {
            filterType: "Summary Bookwise",
            username: user?.username,
            role: user?.role,
          });
        }
      } catch (err) {
        logger.error("Error occur during summary report filter", {
          error: err,
        });
        console.error("Dispatch failed", err);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
          marginBottom: 2,
        }}
      >
        <TextField
          label="From Book No"
          value={fromBookNo}
          onChange={(e) => {
            const value = e.target.value;
            if (/^[a-zA-Z0-9]*$/.test(value)) {
              setFromBookNo(value);
            }
          }}
          size="small"
        />
        <TextField
          label="To Book No"
          value={toBookNo}
          onChange={(e) => {
            const value = e.target.value;
            if (/^[a-zA-Z0-9]*$/.test(value)) {
              setToBookNo(value);
            }
          }}
          size="small"
        />

        {/* NEW: Year filter — optional. Empty = Format 1 (year grouped),
            selected = Format 2 (that year only) */}
       {reportFormat === "yearFilter" && (
  <FormControl size="small" sx={{ minWidth: 130 }}>
    <InputLabel>Year</InputLabel>
    <Select label="Year" value={year} onChange={(e) => setYear(e.target.value)}>
      <MenuItem value="">All Years</MenuItem>
      {yearOptions.map((y) => (
        <MenuItem key={y} value={y}>{y}</MenuItem>
      ))}
    </Select>
  </FormControl>
)}

        <Button
          variant="contained"
          color="primary"
          onClick={() => handleFilter()}
        >
          Apply Filter
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handlefetchall()}
        >
          Overall Bookwise Summary
        </Button>
      </Box>

      {loading ? (
        <Box textAlign="center" mt={2}>
          <CircularProgress />
        </Box>
      ) : summary || summary.length > 0 ? (
          <SummaryPage data={summary} type={summaryType} reportFormat={reportFormat} />
      ) : (
        isClicked && (
          <Box textAlign="center" mt={2} fontWeight="bold" color="black">
            No Summary Available
          </Box>
        )
      )}
    </>
  );
};

export default SummaryFilter;